module.exports = __webpack_public_path__ + "09_face.c7c353e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer1/09_face.png
// module id = JP0d
// module chunks = 0